export const GET_LOADPARAMS_FORMS = 'GET_LOADPARAMS_FORMS';
export const GET_OFFERED_COURSES = 'GET_OFFERED_COURSES';
export const GET_REGISTERED_COURSES = "GET_REGISTERED_COURSES";
export const GET_DISPLAYED_REGISTERED_COURSES = "GET_DISPLAYED_REGISTERED_COURSES";
export const GET_WAITINGLIST = "GET_WAITINGLIST";
export const GET_TRANSCRIPT_TABLE = "GET_TRANSCRIPT_TABLE";
export const GET_DROPPED_TABLE = "GET_DROPPED_TABLE";
export const GET_REGISTERED_TEMP_COURSES = "GET_REGISTERED_TEMP_COURSES";
export const GET_UNOFFICIAL_WAITINGLIST = 'GET_UNOFFICIAL_WAITINGLIST';
export const DELETE_UNOFFICIAL_WAITINGLIST = 'DELETE_UNOFFICIAL_WAITINGLIST';
export const DROPPED_UNOFFICIAL_COURSES = 'DROPPED_UNOFFICIAL_COURSES';
export const SET_WAITING_DATA_FETCHED = 'SET_WAITING_DATA_FETCHED';


export const SET_REGISTER_SEMAPHORE_REQUEST = 'SET_REGISTER_SEMAPHORE_REQUEST';
export const SET_REGISTER_SEMAPHORE_SUCCESSFULLY = 'SET_REGISTER_SEMAPHORE_SUCCESSFULLY';
export const SET_REGISTER_SEMAPHORE_ERROR = 'SET_REGISTER_SEMAPHORE_ERROR';


export const RESET_REGISTER_SEMAPHORE_REQUEST = 'RESET_REGISTER_SEMAPHORE_REQUEST';
export const RESET_REGISTER_SEMAPHORE_SUCCESSFULLY = 'RESET_REGISTER_SEMAPHORE_SUCCESSFULLY';
export const RESET_REGISTER_SEMAPHORE_ERROR = 'RESET_REGISTER_SEMAPHORE_ERROR';